"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EndpointHeadersOut = void 0;
class EndpointHeadersOut {
    constructor() {
    }
    static getAttributeTypeMap() {
        return EndpointHeadersOut.attributeTypeMap;
    }
}
exports.EndpointHeadersOut = EndpointHeadersOut;
EndpointHeadersOut.discriminator = undefined;
EndpointHeadersOut.attributeTypeMap = [
    {
        "name": "headers",
        "baseName": "headers",
        "type": "{ [key: string]: string; }",
        "format": ""
    },
    {
        "name": "sensitive",
        "baseName": "sensitive",
        "type": "Array<string>",
        "format": ""
    }
];
//# sourceMappingURL=EndpointHeadersOut.js.map